// extracted by mini-css-extract-plugin
export default {"buttons":"CouncilBanksPage_buttons__h7o0y"};